import React from "react";

import { useTranslation } from "utils";

import { ScenarioData } from "pages/app/scenario-analysis/types/scenario";
import { scenarioLineColor } from "pages/app/scenario-analysis/utils/forecast";

export interface ScenarioPillsProps {
  scenarios: ScenarioData[];
  /** The full scenario list. Colours resolve against it, so a filtered pill keeps its colour. */
  colorSource: ScenarioData[];
  isSelected: (scenario: ScenarioData) => boolean;
  onSelect: (scenarioId: string) => void;
  dataTestId?: string;
}

const PREFIX = "detailedCalculations.";

export const ScenarioPills = ({ scenarios, colorSource, isSelected, onSelect, dataTestId = "detailed-calculations" }: ScenarioPillsProps) => {
  const { t } = useTranslation("scenarioAnalysis");

  return (
    <div className="detailed-calculations-scenario-picker" data-testid={`${dataTestId}-scenario-picker`}>
      {scenarios.map((scenario) => {
        const selected = isSelected(scenario);
        const color = scenarioLineColor(colorSource, scenario.id);

        return (
          <button
            key={scenario.id}
            type="button"
            className={`detailed-calculations-pill${selected ? " detailed-calculations-pill-active" : ""}`}
            style={selected ? { backgroundColor: color, borderColor: color } : undefined}
            onClick={() => onSelect(scenario.id)}
            title={scenario.title}
            aria-pressed={selected}
            data-testid={`${dataTestId}-pill-${scenario.id}`}
          >
            <span
              className={`detailed-calculations-pill-dot${selected ? " detailed-calculations-pill-dot-on-fill" : ""}`}
              style={selected ? undefined : { backgroundColor: color }}
              aria-hidden
            />
            {scenario.title}
            {scenario.isBaseline ? (
              <span className={`detailed-calculations-pill-baseline${selected ? " detailed-calculations-pill-baseline-on-fill" : ""}`}>
                {t(`${PREFIX}baselineSuffix`)}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
};

export default ScenarioPills;
